import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { RouteLoading } from "@/components/RouteLoading";

const PresentationsHubPage = lazy(() => import("@/components/presentations/PresentationsHubPage"));

export const Route = createFileRoute("/_authenticated/presentations/")({
  component: PresentationsIndexRoute,
});

function PresentationsIndexRoute() {
  return (
    <Suspense fallback={<RouteLoading label="Loading presentations..." />}>
      <PresentationsHubPage />
    </Suspense>
  );
}
